module.exports = __webpack_public_path__ + "media/audio4.729d1918.mp3";